import React from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import { LogoField } from "./LogoField";

/**
 * The fields of the team form, shared by Add Team and Update Team (#306). Update used to label only
 * the team name, and drew the sport as a form-control select, which Bootstrap 5 gives no arrow, so
 * it read as a text box. The screen owns the <Form>, its validation and its buttons.
 *
 * @param {object} props
 * @param {string} props.idPrefix Makes the controlIds unique, so each label is tied to its input.
 * @param {{teamName?: string, sportId?: number|string}} props.values The form's values.
 * @param {(event: object) => void} props.onChange Called with the name and sport inputs' change events.
 * @param {Array<{sportId: number, sportName: string}>} [props.sports] The sports a team can belong to.
 * @param {object} props.image The form's useImageUpload.
 * @param {string} [props.placeholderImage] The logo shown while the team has none.
 * @param {boolean} [props.busy] Shows the logo field's loader while the save is on its way.
 */
export const TeamFormFields = ({ idPrefix, values, onChange, sports, image, placeholderImage, busy }) => (
  <Row className="mb-3">
    <Form.Group as={Col} md="6" controlId={`${idPrefix}-name`}>
      <Form.Label>Team Name</Form.Label>
      <Form.Control
        required
        type="text"
        maxLength={50}
        name="teamName"
        value={values?.teamName ?? ""}
        onChange={onChange}
        placeholder="Team Name"
      />
      <Form.Control.Feedback type="invalid">Please enter valid Team name.</Form.Control.Feedback>
    </Form.Group>

    <Form.Group as={Col} md="6" className="text-left" controlId={`${idPrefix}-sport`}>
      <Form.Label>Sport Name</Form.Label>
      <InputGroup hasValidation>
        <Form.Select name="sportId" value={values?.sportId ?? ""} onChange={onChange} required>
          <option value="">Select Sports</option>
          {(sports || []).map((sport) => (
            <option key={sport.sportId} value={sport.sportId}>
              {sport.sportName}
            </option>
          ))}
        </Form.Select>
        <Form.Control.Feedback type="invalid">Please select a sport name.</Form.Control.Feedback>
      </InputGroup>
    </Form.Group>

    <Form.Group as={Col} md="12 mt-2" controlId={`${idPrefix}-logo`}>
      <LogoField name="teamImage" image={image} placeholder={placeholderImage} busy={busy} />
    </Form.Group>
  </Row>
);
